<template>
    <IndexBase @auth="onAuth($event)" action="Index" controller="BaWithSpo"></IndexBase>
    <form id="mainForm" action="#" method="post">
        <Card>
            <template #title>
                <Toolbar>
                    <template #left>
                        <div class="p-card-title">
                            [{{ mode }}] BAIK WITH SPO
                        </div>
                        <div style="margin-left: 10px" v-if="mode != this.$FORM_MODE_CREATE">
                            <Button type="button" icon="pi pi-info" @click="toggle" aria:haspopup="true"
                                aria-controls="overlay_panel" class="p-button-rounded p-button-outlined p-button-sm" />

                            <OverlayPanel ref="op" appendTo="body" :showCloseIcon="true" id="overlay_panel"
                                style="width: 550px" :breakpoints="{ '960px': '80vw' }">
                                <div class="grid field">
                                    <div class="row">
                                        <i class="pi pi-plus-circle" /> {{ this.$formatDateTime(header.Created_Date) }}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{ header.Created_By }}
                                    </div>
                                </div>
                                <div class="grid field" v-if="header.Edited_Date">
                                    <div class="row">
                                        <i class="pi pi-pencil" /> {{ this.$formatDateTime(header.Edited_Date) }}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{ header.Edited_By }}
                                    </div>
                                </div>
                                <div class="grid field" v-if="header.Deleted_Date">
                                    <div class="row">
                                        <i class="pi pi-trash" /> {{ this.$formatDateTime(header.Deleted_Date) }}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{ header.Deleted_By }}
                                    </div>
                                </div>
                            </OverlayPanel>
                        </div>
                    </template>

                    <template #right>
                        <Button icon="pi pi-chevron-left" label="Back" class="p-button mr-2" @click="backToIndex" />
                        <Button icon="pi pi-save" label="Draft" class="p-button-secondary mr-2" @click="confirmDraft($event)" v-if="mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW && (header && header.Status != this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL && header.Status != this.$APPROVAL_STATUS.APPROVED && header.Status != this.$APPROVAL_STATUS.REVISED && header.Status != this.$APPROVAL_STATUS.DONE)"/>
                        <Button icon="pi pi-upload" label="Save" class="p-button-success" @click="confirm($event)" v-if="mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW && !onlyDraft" />
                        <Button icon="pi pi-trash" label="Delete" class="p-button-danger" @click="confirm($event)"
                            v-if="mode == this.$FORM_MODE_DELETE" />
                        <ConfirmPopup></ConfirmPopup>
                    </template>
                </Toolbar>
            </template>
            <template #content>
                <div class="p-inputtext-sm p-fluid">
                    <div class="grid">
                        <div class="col-6">

                            <FormField :labelName="$t('doc_date')" fieldName="Doc_Date" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <DatePicker name="doc_date" v-model="header.Doc_Date" type="text"
                                :placeholder="$t('doc_date')" v-if="header" dateFormat="dd/mm/yyyy"
                                inputMask="99/99/9999" momentFormat="DD/MM/YYYY"
                                :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"/>
                                <small
                                    v-if="header && !header.Doc_Date && submitted && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t('doc_date')) }}
                                </small>
                            </FormField>

                            <FormField :labelName="$t('doc_no')" fieldName="Doc_No" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputText name="Doc_No" v-model="header.Doc_No" required="true" type="text"
                                    :placeholder="$t('doc_no')" v-if="header"
                                    :disabled="true" />
                                    <!-- <small v-if="header && !header.Doc_No && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('doc_no')) }}
                                     </small> -->
                            </FormField>

                            <FormField :labelName="$t('job_desc')" fieldName="Deskripsi_Pekerjaan" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputText name="Deskripsi_Pekerjaan" v-model="header.Deskripsi_Pekerjaan" required="true" type="text"
                                    :placeholder="$t('job_desc')" v-if="header"
                                    :disabled="true" />
                                    <small v-if="header && !header.Deskripsi_Pekerjaan && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('job_desc')) }}
                                    </small>
                            </FormField>

                            <FormField :labelName="$t('company_contractor')" fieldName="Contractor_Code" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <CustomSelect name="Contractor_Code" :filter="true"  v-if="header"
                                    v-model="header.Contractor_Code" required="true" 
                                    placeholder="Please Select"
                                    :url="$API_URL + 'list/contractor_code'"
                                    :minLength="0"
                                    :params="{ docDate: (this.header.Doc_Date != null ? this.header.Doc_Date  : null)}" 
                                    :disabled="true"
                                    />
                                    <small v-if="header && !header.Contractor_Code && submitted && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t('company_contractor')) }}
                                </small>
                            </FormField>

                            <div class="field grid">
                                <label for="No_Wo" class="col-4">{{ $t('no_wo') }}</label>
                                <div class="col-6 md-6">
                                    <InputText name="Code" v-model="header.No_WO" type="text" :placeholder="$t('no_wo')"
                                        v-if="header"
                                        :disabled="true"/>
                                    <Skeleton v-else-if="!header" />
                                    <small v-if="header && !header.No_WO && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('no_wo')) }}
                                    </small>
                                </div>
                            </div>
                       
                            <FormField :labelName="$t('no_spo')" fieldName="No_SPO" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputText name="No_SPO" v-model="header.No_SPO" required="true" type="text"
                                    :placeholder="$t('no_spo')" v-if="header"
                                    :disabled="true" />
                                    <small v-if="header && !header.No_SPO && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('no_spo')) }}
                                     </small>
                            </FormField>
                            
                            <FormField :labelName="$t('contract_value')" fieldName="Nilai_Kontrak" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputNumber name="Nilai_Kontrak" v-model="header.Nilai_Kontrak" required="true"  :useGrouping="true" :maxFractionDigits="2" :minFractionDigits="0"
                                    :placeholder="$t('contract_value')" v-if="header"
                                    :disabled="true" />
                                    <small v-if="header && !header.Nilai_Kontrak && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('contract_value')) }}
                                    </small>
                            </FormField>

                            <FormField :labelName="$t('budget')" fieldName="Budget" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputText name="Budget" v-model="header.Budget" required="true"
                                    :placeholder="$t('budget')" v-if="header"
                                    :disabled="true" />
                                    <small v-if="header && !header.Budget && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('budget')) }}
                                    </small>
                            </FormField>

  
                            
                        </div>  
                        <div class="col-6">
                            
                            <FormField :labelName="$t('status')" fieldName="Status" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputText name="Status" v-model="header.Status" required="true" type="text"
                                    :placeholder="$t('status')" v-if="header"
                                    :disabled="true" />
                            </FormField>

                            <FormField :labelName="$t('tanggal_mulai_pekerjaan')" fieldName="Tanggal_Mulai_Pekerjaan" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <DatePicker name="tanggal_mulai_pekerjaan" v-model="header.Tanggal_Mulai_Pekerjaan" type="text"
                                :placeholder="$t('tanggal_mulai_pekerjaan')" v-if="header" dateFormat="dd/mm/yyyy"
                                inputMask="99/99/9999" momentFormat="DD/MM/YYYY"
                                :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"/>
                                <small
                                    v-if="header && !header.Tanggal_Mulai_Pekerjaan && submitted && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t('tanggal_mulai_pekerjaan')) }}
                                </small>
                            </FormField>

                            <FormField :labelName="$t('spo_date')" fieldName="Tanggal_SPO" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <DatePicker name="spo_date" v-model="header.Tanggal_SPO" type="text"
                                :placeholder="$t('spo_date')" v-if="header" dateFormat="dd/mm/yyyy"
                                inputMask="99/99/9999" momentFormat="DD/MM/YYYY"
                                :disabled="true"/>
                                <small
                                    v-if="header && !header.Tanggal_SPO && submitted && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t('spo_date')) }}
                                </small>
                            </FormField>

                            <FormField :labelName="$t('job_completion_time')" fieldName="Waktu_Penyelesaian_Pekerjaan" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputNumber name="Waktu_Penyelesaian_Pekerjaan" v-model="header.Waktu_Penyelesaian_Pekerjaan" required="true" type="text"
                                :placeholder="$t('job_completion_time')" v-if="header"
                                :disabled="true" 
                                :useGrouping="false" :min="1"/>
                                <small
                                    v-if="header && !header.Waktu_Penyelesaian_Pekerjaan && submitted && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t('job_completion_time')) }}
                                </small>
                            </FormField>
                            
                            <FormField :labelName="$t(labelAppr1)" fieldName="Username_PIC_PM" v-model="header" labelClass="col-4" fieldClass="col-6" v-if="labelAppr1">
                                <CustomSelect name="Username_PIC_PM" :filter="true"  v-if="header"
                                    v-model="header.Username_PIC_PM" required="true" 
                                    placeholder="Please Select"
                                    :url="$API_URL + 'list/usernameWilmar'"
                                    :minLength="0"
                                    :params="{job_postion : header.Appr_As1, user_type:this.$UserType.WILMAR, doc_type : this.$TypeDocument.BA_IK_WITH_SPO, companycode: header.Company_Code, contractorcode : header.Contractor_Code }" 
                                    :disabled="true"/>
                                    <small v-if="header && !header.Username_PIC_PM && submitted2 && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t(labelAppr1)) }}
                                </small>
                            </FormField>

                            <FormField :labelName="$t(labelAppr2)" fieldName="Username_PIC_Contractor" v-model="header" labelClass="col-4" fieldClass="col-6" v-if="labelAppr2">
                                <CustomSelect name="Username_PIC_Contractor" :filter="true"  v-if="header"
                                    v-model="header.Username_PIC_Contractor" required="true" 
                                    placeholder="Please Select"
                                    :url="$API_URL + 'list/usernameWilmar'"
                                    :minLength="0"
                                    :params="{job_postion : header.Appr_As2, user_type:this.$UserType.WILMAR, doc_type : this.$TypeDocument.BA_IK_WITH_SPO,companycode: header.Company_Code,  contractorcode : header.Contractor_Code  }" 
                                    :disabled="true"/>
                                    <small v-if="header && !header.Username_PIC_Contractor && submitted2 && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t(labelAppr2)) }}
                                </small>
                            </FormField>

                            <FormField :labelName="$t(labelAppr3)" fieldName="Username_PIC_CP" v-model="header" labelClass="col-4" fieldClass="col-6" v-if="labelAppr3">
                                <CustomSelect name="Username_PIC_CP" :filter="true"  v-if="header"
                                    v-model="header.Username_PIC_CP" required="true" 
                                    placeholder="Please Select"
                                    :url="$API_URL + 'list/usernameWilmar'"
                                    :minLength="0"
                                    :params="{job_postion : header.Appr_As3, user_type:this.$UserType.WILMAR, doc_type : this.$TypeDocument.BA_IK_WITH_SPO, companycode: header.Company_Code, contractorcode : header.Contractor_Code }" 
                                    :disabled="true"/>
                                    <small v-if="header && !header.Username_PIC_CP && submitted2 && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t(labelAppr3)) }}
                                </small>
                            </FormField>

                            <FormField :labelName="$t('reason')" fieldName="Reason" v-model="header" labelClass="col-4" fieldClass="col-6" v-if="header && (header.Status == this.$APPROVAL_STATUS.DONE || header.Status == this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL)">
                                <InputText name="Reason" v-model="header.Reason" required="true" type="text"
                                    :placeholder="$t('reason')" v-if="header"
                                    :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT|| header.Status != this.$APPROVAL_STATUS.DONE"/>
                                    <small v-if="header &&((!header.Reason && header.Status == this.$APPROVAL_STATUS.DONE)) && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('reason')) }}
                                    </small>
                            </FormField>

                        </div>
                        <div class="col-8" v-if="header && header.activeMC">
                            <h5 class="mb-2">Scope BoQ</h5>
                            <div style="max-height: 400px; overflow: auto;">
                                <DataTable v-if="header" :value="header.ScopeBoQ"
                                        class="p-datatable-sm editable-cells-table"
                                        showGridlines>
                                    <Column field="Section_Type" :header="$t('type')" style="width: 100px; max-width: 100px; min-width: 100px;">
                                        <template #body="slotProps">
                                            <InputText 
                                                v-model="slotProps.data.Section_Type" 
                                                :disabled="true"
                                            />
                                        </template>
                                    </Column>
                                    <Column field="No_BoQ" :header="$t('no')" style="width: 80px; max-width: 80px; min-width: 80px;">
                                        <template #body="slotProps">
                                            <InputText 
                                                v-model="slotProps.data.No_BoQ" 
                                                :disabled="true"
                                            />
                                        </template>
                                    </Column>
                                    <Column field="Scope" :header="$t('scope')" style="width: 300px; max-width: 300px; min-width: 300px;">
                                        <template #body="slotProps">
                                            <Textarea 
                                                v-model="slotProps.data.Scope" 
                                                :disabled="true"
                                            />
                                        </template>
                                    </Column>
                                    <Column field="Unit" :header="$t('unit')" style="width: 80px; max-width: 80px; min-width: 80px;">
                                        <template #body="slotProps">
                                            <InputText 
                                                v-model="slotProps.data.Unit" 
                                                :disabled="true"
                                            />
                                        </template>
                                    </Column>
                                    <Column field="Volume" :header="$t('volume')" style="width: 100px; max-width: 100px; min-width: 100px;">
                                        <template #body="slotProps">
                                            <InputNumber 
                                                v-model="slotProps.data.Volume" 
                                                :disabled="true"
                                                v-lock-input="true"
                                                :maxFractionDigits="6"
                                                :minFractionDigits="0"
                                            />
                                        </template>
                                    </Column>
                                </DataTable>
                            </div>
                        </div>
                        <div class="col-6" v-if="header && !header.activeMC">
                            <DataTable v-if="header" :loading="!header" :value="header.Scopes ? header.Scopes : null"
                                responsiveLayout="scroll" class="p-datatable-sm editable-cells-table">
                                <Column :exportable="false" style="width:30px">
                                    <template #header>
                                        <Button label="" icon="pi pi-plus" class="p-button-primary p-mr-2 p-button-sm"
                                            @click="addDetailScope()"
                                            :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT" />
                                        </template>
                                        <template #body="slotProps">
                                            <Button icon="pi pi-minus" class="p-button-danger p-mr-2 p-button-sm"
                                                @click="deleteDetailScope(slotProps)"
                                                :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                                v-show="slotProps.data.mode != 'Delete'" />
                                        </template>
                                    </Column>
                                    <Column field="Description" :header="$t('scope')" Key="Id">
                                        <template #body="slotProps">
                                            <div class="p-fluid">
                                                <Textarea 
                                                    v-model="slotProps.data[slotProps.column.props.field]" required="true"
                                                    :placeholder="$t('description')" @change="onCellEditCompleteScope(slotProps)"
                                                    :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                                    v-show="slotProps.data.mode != 'Delete'" />
                                            </div>
                                        </template>
                                    </Column>
                            </DataTable>
                        </div>
                        <div class="col-6" v-if="header && !header.activeMC">
                                <DataTable v-if="header" :loading="!header" :value="header.Reasons ? header.Reasons : null"
                                    responsiveLayout="scroll" class="p-datatable-sm editable-cells-table">
                                    <Column :exportable="false" style="width:30px">
                                        <template #header>
                                            <Button label="" icon="pi pi-plus" class="p-button-primary p-mr-2 p-button-sm"
                                                @click="addDetailReason()"
                                                :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT" />
                                        </template>
                                        <template #body="slotProps">
                                            <Button icon="pi pi-minus" class="p-button-danger p-mr-2 p-button-sm"
                                                @click="deleteDetailReason(slotProps)"
                                                :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                                v-show="slotProps.data.mode != 'Delete'" />
                                        </template>
                                    </Column>
                                    <Column field="Description" :header="$t('reason')" Key="Id">
                                        <template #body="slotProps">
                                            <div class="p-fluid">
                                                <Textarea 
                                                    v-model="slotProps.data[slotProps.column.props.field]" required="true"
                                                    :placeholder="$t('description')" @change="onCellEditCompleteReason(slotProps)"
                                                    :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                                    v-show="slotProps.data.mode != 'Delete'" />
                                            </div>
                                        </template>
                                    </Column>
                                </DataTable>
                        </div>

                        <div class="col-12 mt-4" v-if="this.mode != this.$FORM_MODE_CREATE">
                            <TabView>
                                <TabPanel :header="$t('log_history')">
                                    <ChangeHistory v-if="this.header" :modelValue="this.dataModelReqLogs"
                                        :dataRequestLog="this.dataRequestLogs" :mode="this.mode"></ChangeHistory>
                                </TabPanel>
                                <TabPanel :header="$t('release_approval')">
                                    <ChangeHistory angeHistory v-if="this.header" :modelValue="this.dataModelRelease"
                                        :dataRequestLog="this.dataRelease" :mode="this.mode"></ChangeHistory>
                                </TabPanel>
                                <TabPanel :header="$t('Change_History')">
                                    <ChangeHistory v-if="this.header" :modelValue="this.detailLog" :dataRequestLog="this.dataChangesLog" :mode="this.mode"></ChangeHistory>
                                </TabPanel>
                            </TabView>
                        </div>
                    </div>
                </div>
            </template>
        </Card>
    </form>
</template>


<script>
import moment from 'moment';
import IndexBase from '../Helper/IndexBase.vue'
export default {
    name: "Editor",
    components: {
        IndexBase
    },
    data() {
        return {
            indexName: "BaWithSpoIndex",
            url: this.$API_URL + "bawithspo/",
            header: null,
            detail: null,
            mode: "",
            submitted: false,
            id: 0,
            mainid : 0,
            formEditable: true,
            dataModelReqLogs: [],
            dataRequestLogs: [
                { field: "Action_Role", header: "Role" },
                { field: "Action_By", header: "Action By" },
                { field: "Action", header: "Action" },
                { field: "Action_Date", header: "Action Date" },
                { field: "Notes", header: "Notes" },
            ],
            dataModelRelease: [],
            dataRelease: this.$dataRelease,
            viewFiles : null,
            reason : null,
            scope : null,
            detailLog : null,
            dataChangesLog:this.$dataChangesLog,
            labelAppr1 : "",
            labelAppr2 : "",
            labelAppr3 : "",
            listAppr : [],
            submitted2 : false,
            onlyDraft : false
        }
    },
    methods: {
        getData() {
            var self = this;
            this.$axios.get(this.url + this.mainid + "/" +this.id + "/" + this.mode)
                .then((response) => {
                    if(response.data.success){
                        self.header = response.data.data.header;
                        self.header.mode = self.mode;
                        self.detail = response.data.data.detail;
                        self.dataModelReqLogs = response.data.data.header.request_log;
                        self.dataModelRelease = response.data.data.header.approval_log;
                        self.reason = response.data.data.reason;
                        self.scope = response.data.data.scope;
                        self.detailLog = self.header.DetailLog;

                        self.listAppr = response.data.data.listPicAppr;
                        if(self.listAppr.length > 0)
                        {
                            self.listAppr.forEach(a=>{
                                if(a.Sign_Position == 1){
                                    self.labelAppr1 = a.Approval_As;
                                    self.header.Appr_As1 = a.Approval_As;
                                    self.header.Sign_Position1 =  a.Sign_Position;
                                }
                                else if(a.Sign_Position == 2){
                                    self.labelAppr2 = a.Approval_As;
                                    self.header.Appr_As2 = a.Approval_As;
                                    self.header.Sign_Position2 =  a.Sign_Position;
                                }
                                else if(a.Sign_Position == 3){
                                    self.labelAppr3 = a.Approval_As;
                                    self.header.Appr_As3 = a.Approval_As;
                                    self.header.Sign_Position3 =  a.Sign_Position;
                                }
                            });
                        }
                        
                    }else{
                        self.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: this.$DEFAULT_TIMER });
                    }
                })
                .catch(function (error) {
                    self.showError("Error", error);
                });
        },
        onAuth(event) {
            this.onlyDraft = event.onlyDraft;
        },
        saveData() {
            this.$emit('block-ui');
            var self = this;

            if(this.header){        
                this.header.Doc_Date_String  = moment(this.header.Doc_Date).format('YYYY/MM/DD').toString();
                this.header.Tanggal_Mulai_Pekerjaan_String =  moment(this.header.Tanggal_Mulai_Pekerjaan).format('YYYY/MM/DD').toString();
            }
            
             this.$axios.post(this.url, this.header)
                .then((response) => {
                    if (response.data.success) {
                        if (this.mode == this.$FORM_MODE_DELETE) {
                            self.$router.push({ name: self.indexName, params: { showToast: true, severity: 'success', summary: 'Data Deleted', detail: "BA IK With SPO has been deleted successfully", life: 3000 } });
                        } else {
                            self.$router.push({ name: self.indexName, params: { showToast: true, severity: 'success', summary: 'Data Saved', detail: "BA IK With SPO has been saved successfully", life: 3000 } });
                        }

                    }
                    else {
                        self.showError('Error Saving Data', response.data.message);
                    }
                })
                .catch(function (error) {
                    self.showError('Error Saving Data', error);
                });
        },
        showError(summary, message) {
            this.$emit('unblock-ui');
            this.$toast.add({ severity: 'error', summary: summary, detail: message, life: 3000 });
        },
        backToIndex() {
            if(this.$router.options.history.state.back != null)
                this.$router.push({ path: this.$router.options.history.state.back });
            else 
              this.$router.push({ path: "Index" });
        },
        toggle(event) {
            this.$refs.op.toggle(event);
        },
        confirm(event) {
            this.submitted = true;
            this.submitted2 = true;
            var self = this;
            if(self.mode != this.$FORM_MODE_DELETE){
                //|| !this.header.Username_PIC_CP || !this.header.Username_PIC_PM || !this.header.Username_PIC_Contractor
                if (!this.header.Doc_Date || !this.header.Contractor_Code || !this.header.Deskripsi_Pekerjaan||
                    !this.header.No_SPO || !this.header.No_WO || !this.header.Nilai_Kontrak || !this.header.Budget || !this.header.Tanggal_Mulai_Pekerjaan||
                    !this.header.Tanggal_SPO || !this.header.Waktu_Penyelesaian_Pekerjaan || (this.labelAppr3 && !this.header.Username_PIC_CP) || (this.labelAppr1 && !this.header.Username_PIC_PM) || (this.labelAppr2 && !this.header.Username_PIC_Contractor)|| 
                    (!this.header.Reason && this.header.Status == this.$APPROVAL_STATUS.DONE)) {
                    return;
                }
            
                // if(this.header.files_data == null && this.mode == this.$FORM_MODE_CREATE){
                //     self.showError("Error", "Must have attachment")
                //     return;
                // }   
                
                var reasons = this.header.Reasons.filter(a=> a.mode != this.$FORM_MODE_DELETE && a.Description);
                var scopes = this.header.Scopes.filter(a=> a.mode != this.$FORM_MODE_DELETE && a.Description);

                if(reasons.length  == 0 && !this.header.activeMC){
                    self.showError("Error", "Must have one reason")
                    return;
                }
                if(scopes.length  == 0 && !this.header.activeMC){
                    self.showError("Error", "Must have one scope")
                    return;
                }

            }
         

            this.$confirm.require({
                target: event.currentTarget,
                message: 'Are you sure?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    this.saveData();
                },
                reject: () => {

                }
            });
            
        },
        confirmDraft(event) {
            this.submitted = true;
            this.submitted2 = false;
            var self = this;
            //| !this.header.Username_PIC_CP || !this.header.Username_PIC_PM || !this.header.Username_PIC_Contractor
            if (!this.header.Doc_Date || !this.header.Contractor_Code || !this.header.Deskripsi_Pekerjaan||
                !this.header.No_SPO || !this.header.No_WO || !this.header.Nilai_Kontrak || !this.header.Budget || !this.header.Tanggal_Mulai_Pekerjaan||
                !this.header.Tanggal_SPO || !this.header.Waktu_Penyelesaian_Pekerjaan) {
                return;
            }

            // if(this.header.Reasons.length == 0){
            //     self.showError("Error", "Must have one reason")
            //     return;
            // }
            // if(this.header.Scopes.length == 0){
            //     self.showError("Error", "Must have one scope")
            //     return;
            // }
            // if(this.header.files_data == null && this.mode == this.$FORM_MODE_CREATE){
            //     self.showError("Error", "Must have attachment")
            //     return;
            // }   

            // if(this.header.Reasons.length == 0){
            //     self.showError("Error", "Must have one reason")
            //     return;
            // }
            // if(this.header.Scopes.length == 0){
            //     self.showError("Error", "Must have one scope")
            //     return;
            // }

            this.$confirm.require({
                target: event.currentTarget,
                message: 'Are you sure save as draft ?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    if(this.mode == this.$FORM_MODE_CREATE)
                        this.header.mode = this.$FORM_MODE_DRAFT;
                    else if(this.mode == this.$FORM_MODE_EDIT)
                            this.header.mode = this.$FORM_MODE_DRAFT_EDIT;
                    else
                        this.header.mode = this.mode;
                    this.saveData();
                },
                reject: () => {

                }
            });
            
        },
        hideRow(data) {
            return data.mode == this.$FORM_MODE_DELETE ? 'row-hidden' : null;
        },
        addDetailReason() {
            var newDetail = this.reason;
            newDetail.mode = this.$FORM_MODE_CREATE;
            var det = { ...newDetail };

            this.header.Reasons.push(det);
        },
        deleteDetailReason(event) {
            if (event) {
                var detail = this.header.Reasons[event.index];

                if (detail.mode == this.$FORM_MODE_CREATE) this.header.Reasons.splice(this.header.Reasons.indexOf(detail), 1);
                else detail.mode = this.$FORM_MODE_DELETE;
            }
        },
        onCellEditCompleteReason(event) {
            this.editDetailReason(event.index);
        },
        editDetailReason(index) {
            if (this.header && this.header.Reasons) {
                let mode = this.header.Reasons[index].mode;

                if (mode == this.$FORM_MODE_UNCHANGED) {
                    this.header.Reasons[index].mode = this.$FORM_MODE_EDIT;
                }
            }
        },
        addDetailScope() {
            var newDetail = this.scope;
            newDetail.mode = this.$FORM_MODE_CREATE;
            var det = { ...newDetail };

            this.header.Scopes.push(det);
        },
        deleteDetailScope(event) {
            if (event) {
                var detail = this.header.Scopes[event.index];

                if (detail.mode == this.$FORM_MODE_CREATE) this.header.Scopes.splice(this.header.Scopes.indexOf(detail), 1);
                else detail.mode = this.$FORM_MODE_DELETE;
            }
        },
        onCellEditCompleteScope(event) {
            this.editDetailScope(event.index);
        },
        editDetailScope(index) {
            if (this.header && this.header.Scopes) {
                let mode = this.header.Scopes[index].mode;

                if (mode == this.$FORM_MODE_UNCHANGED) {
                    this.header.Scopes[index].mode = this.$FORM_MODE_EDIT;
                }
            }
        },
        onFileRemove(files,data) {
                data.files_data = [];
                for(var i = 0; i<files.length;i++){
                    data.files_data.push(event.files[i]);
                }
        },
        onFileSelect(event, data) {
                data.files_data = [];
                for(var i = 0; i<event.files.length;i++){
                    data.files_data.push(event.files[i]);
                }
        },
        onFileSelectUpload(event) {
            this.detailFiles = event.files;
            this.uploadFile = true;
        },
        onDownloadFile(file){
            var self = this;
            this.$axios.get(this.url + "download_attachment/" + file.id + "/" + file.name, {
                responseType: 'blob',
                timeout: this.$AXIOS_TIMEOUT_LONG
                })
                .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', file.name);
                    document.body.appendChild(link);
                    link.click();
                    
                })
                .catch(function (err) {
                    self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: "File not found" + err, life: 120000});
                    self.blocked = false;
                    //self.showAssignModal = false;
                });
        },
    },
    created() {
        this.mode = this.$route.query.mode;
        this.id = this.$route.query.id ?? 0;
        this.mainid = this.$route.query.mainid ?? 0;
        this.getData();
        if(this.$router.options.history.state.back != null){
            var indexName = this.$router.options.history.state.back.split("/");
            if(indexName[1] == "MainData")
                this.indexName = "MainDataIndex";
        }
    }
}
</script>

<style scoped>
/* Table base styling */
::v-deep(.editable-cells-table) {
   font-size: 1rem;
}

::v-deep(.editable-cells-table .p-inputtext),
::v-deep(.editable-cells-table .p-inputnumber-input),
::v-deep(.editable-cells-table .p-inputtextarea) {
   font-size: 1rem;
   width: 100%;
}

::v-deep(.p-datatable .p-datatable-tbody > tr > td) {
   white-space: normal;
   word-wrap: break-word;
}

/* Textarea height */
::v-deep(.p-datatable .p-datatable-tbody > tr > td textarea) {
   min-height: 60px;
}
</style>